import { ElementRef, Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { TranslatorService } from './translator.service';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import authHeader from '../helpers/auth-header';
import NationState from '../interfaces/NationState';
import axios from 'axios';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';

@Injectable({
     providedIn: 'root'
})
export class GeneralService {
     public setRoute = '';
     private _Session_Key: string = "";
     public _Session_custID: string = "";
     constructor (public translatorService: TranslatorService, private http: HttpClient, private router: Router) { }

     openDocument(docName: string) {
          const docUrl = `${environment.APP_PSP_DOC_BASE_URL}/getByName/${docName}.pdf`;
          window.open(docUrl, '_blank')?.focus();
     }

     getTranslation(tag: string, file: string = 'na'): string {
          if (tag) {
               const returnValue = this.translatorService.getTextForTag(tag)
               return returnValue;
          }
          return '';
     }

     get route() {
          return this.setRoute;
     }

     getLoginGovUrl(authCode?: string): any {
          // let testlogin = prompt("PSP IS DOWN FOR MAINTENANCE");
          // if (testlogin == null || testlogin.toLowerCase() != "let me in") {
          //      return false
          // }
          const url = `${environment.APP_API_URL}/api/OIDCAuthentication/SignIn?authCode=${authCode}`;
          return this.http.get(url, { responseType: 'text' })
               .pipe(
                    map((response: any) => response),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     logActivity(action:string, email: string = "System", 
          identifiers: Record<string, string>[] | null = null, 
          infos: Record<string, string>[] | null = null){
          email = email.length > 150 ? email.substring(0, 150) : email;
          action = action.length > 150 ? action.substring(0, 150) : action;
          const url = `${environment.APP_API_URL}/api/v1/ActionLogs/Log`;
          const body = {
               action: action,
               authenticatedEmail: email,
               identifiers: identifiers,
               infos: infos
          };
          this.http.post(url, body).subscribe();
     }

     getFile(file: string): any {
          const url = `${environment.BASE_URL}/assets/content/agreements/${file}.htm`;
          return this.http.get(url, { responseType: 'text' })
               .pipe(
                    map((response: any) => response),
                    catchError(error => {
                         console.error(error);
                         return [];
                    })
               );
     }

     getEndUserIp(): string | any {
          const ipUrl = 'https://api.ipify.org?format=json';
          return this.http.get(ipUrl);
     }

     setIsLoggingIn(code: string, state: string): void {
          localStorage.setItem('code', code);
          localStorage.setItem('state', state);
     }

     getIsLoggingIn() {
          const code: string = localStorage.getItem('code') as string;
          const state: string = localStorage.getItem('state') as string;
          if (code !== null && state !== null) {
               // code and state found in local storage. Return the values and remove from local storage
               localStorage.removeItem('code');
               localStorage.removeItem('state');
               return { "code": code, "state": state };
          } else {
               return null;
          }
     }

     maskEmail(email: string): string {
          const maskedEmail = email.split("");
          let index = 1;
          while (maskedEmail[index] !== "@" && index < maskedEmail.length) {
               maskedEmail[index] = "*";
               index++;
          }
          return maskedEmail.join('');
     }


     gridFooterTxt(footerArea: ElementRef) {
          if (footerArea) {
               const pagingElements = footerArea.nativeElement.parentElement?.querySelectorAll('[id$="-to"], [id$="-of"], [id$="-page"], [id$="-label"], [id$="noResultsFound"]');
               
               if (pagingElements) {
                    pagingElements.forEach((element: any) => {
                         // console.log(element.id)
                         let translationKey = null;
                         if (element.id.endsWith('-to')) {
                              translationKey = 'to_grid';
                         } else if (element.id.endsWith('-of')) {
                              translationKey = 'of_grid';
                         } else if (element.id.endsWith('-page')) {
                              translationKey = element.id.includes('of') ? 'of_grid' : 'page_grid';
                         } else if (element.id.endsWith('-label')) {
                              translationKey = 'page_size_grid';
                         }  
                         if (translationKey) {
                              element.textContent = this.getTranslation(translationKey, 'base');
                         } else if (element.id === 'noResultsFound') {
                              const noResultsFound = this.getTranslation('noResultsFound', 'base');
                              element.innerHtml =`<span class="italic" id="noResultsFound">${noResultsFound}</span>`;
                              element.textContent = noResultsFound;
                         }
                    });
               }
          }
     }

     getStates(): NationState[] | any {
          const url: string = `${environment.APP_API_URL}/api/v1/Geography/getNationStates`;
          return axios.get(url)
               .then((response) => (response.data as []))
               .catch((error) => {
                    console.error(error);
                    console.error('Error loading states.');
                    return [];
               });
     }

     getStatesByCountry(country: string): any {
          const url: string = `${environment.APP_API_URL}/api/v1/Geography/getStates?country=${country}`;
          return axios.get(url)
               .then((response) => (response.data as []))
               .catch((error) => {
                    console.error(error);
                    console.error('Error loading states.');
                    return [];
               });
     }

     getAPIToken() {
          const header = {
               'Content-Type': 'application/json;charset=UTF-8',
               'Authorization': authHeader()
          };
          const url: string = `${environment.APP_API_URL}/api/v1/webservice`;
          return this.http.get(url, { headers: header, responseType: 'text' })
               .pipe(
                    map((response: any) => {
                         return response
                    }),
                    catchError(error => {
                         console.error(error);
                         return '';
                    })
               );
     }

     getMaskedToken() {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };
          const url: string = `${environment.APP_API_URL}/api/v1/webservice/getMaskedToken`;
          return this.http.get(url, config)
               .pipe(
                    map((response: any) => {
                         return response
                    }),
                    catchError(error => {
                         console.error(error);
                         return '';
                    })
               );
     }

     formatDate(theDate: DateTime) {
          return theDate.toFormat('MM/dd/yyyy');
     }

     getQueryParameters(url: string) {
          const regex = /[?&]([^=#]+)=([^&#]*)/g;
          const params: { [key: string]: string } = {};
          let match;

          while ((match = regex.exec(url)) !== null) {
               params[match[1]] = decodeURIComponent(match[2]);
          }

          return params;
     }
}
